import React, { useState } from 'react';

const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScNlzxKkwfJPFm9dJqtws1uZVyvooN0jslw5TKiZA5gSzJ6xA/formResponse';
const ENTRY_NAME = 'entry.2111189145';
const ENTRY_SURNAME = 'entry.1741743583';
const ENTRY_EMAIL = 'entry.903426519';
const ENTRY_REASON = 'entry.2107455880';

export default function DeleteAccountModal({ open, onClose }) {
  const [form, setForm] = useState({ name: '', surname: '', email: '', reason: '' });
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);

  if (!open) return null;

  const validate = () => {
    let errs = {};
    if (!form.name.trim()) errs.name = 'Обязательное поле';
    if (!form.surname.trim()) errs.surname = 'Обязательное поле';
    if (!form.email.trim() || !/^\S+@\S+\.\S+$/.test(form.email)) errs.email = 'Укажите корректный e-mail';
    if (!form.reason.trim()) errs.reason = 'Обязательное поле';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate()) return;
    const formData = new FormData();
    formData.append(ENTRY_NAME, form.name);
    formData.append(ENTRY_SURNAME, form.surname);
    formData.append(ENTRY_EMAIL, form.email);
    formData.append(ENTRY_REASON, form.reason);

    await fetch(GOOGLE_FORM_ACTION, {
      method: 'POST',
      mode: 'no-cors',
      body: formData
    });

    setSent(true);
    setTimeout(() => {
      setSent(false);
      setForm({ name: '', surname: '', email: '', reason: '' });
      setErrors({});
      onClose();
    }, 2000);
  };

  const handleClose = () => {
    setForm({ name: '', surname: '', email: '', reason: '' });
    setErrors({});
    setSent(false);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
    }}>
      <div style={{
        background: '#fff',
        padding: 24,
        borderRadius: 16,
        minWidth: 300,
        maxWidth: '90vw',
        width: 400,
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
      }}>
        <button
          onClick={handleClose}
          style={{
            position: 'absolute', top: 14, right: 14, background: 'transparent',
            border: 'none', fontSize: 22, cursor: 'pointer', color: '#444'
          }}
          aria-label="Закрыть"
        >×</button>
        <h2 style={{ margin: 0, fontWeight: 700, fontSize: 22, textAlign: 'center' }}>Удаление аккаунта</h2>
        {sent ? (
          <div style={{ textAlign: 'center', color: 'green', padding: 24, fontWeight: 600 }}>
            Спасибо! Заявка отправлена.<br />Мы обработаем ваш запрос в ближайшее время.
          </div>
        ) : (
          <form
            style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <input
                name="name"
                placeholder="Имя"
                value={form.name}
                onChange={handleChange}
                style={{
                  padding: '10px 12px', borderRadius: 8, border: errors.name ? '1.5px solid #e63946' : '1px solid #ccc',
                  outline: 'none', fontSize: 16, transition: '.2s'
                }}
                autoFocus
              />
              {errors.name && <span style={{ color: '#e63946', fontSize: 13 }}>{errors.name}</span>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <input
                name="surname"
                placeholder="Фамилия"
                value={form.surname}
                onChange={handleChange}
                style={{
                  padding: '10px 12px', borderRadius: 8, border: errors.surname ? '1.5px solid #e63946' : '1px solid #ccc',
                  outline: 'none', fontSize: 16, transition: '.2s'
                }}
              />
              {errors.surname && <span style={{ color: '#e63946', fontSize: 13 }}>{errors.surname}</span>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <input
                name="email"
                placeholder="E-mail"
                type="email"
                value={form.email}
                onChange={handleChange}
                style={{
                  padding: '10px 12px', borderRadius: 8, border: errors.email ? '1.5px solid #e63946' : '1px solid #ccc',
                  outline: 'none', fontSize: 16, transition: '.2s'
                }}
              />
              {errors.email && <span style={{ color: '#e63946', fontSize: 13 }}>{errors.email}</span>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <textarea
                name="reason"
                placeholder="Причина удаления"
                value={form.reason}
                onChange={handleChange}
                style={{
                  padding: '10px 12px', borderRadius: 8, border: errors.reason ? '1.5px solid #e63946' : '1px solid #ccc',
                  minHeight: 56, fontSize: 16, outline: 'none', resize: 'vertical', transition: '.2s'
                }}
              />
              {errors.reason && <span style={{ color: '#e63946', fontSize: 13 }}>{errors.reason}</span>}
            </div>
            <button
              type="submit"
              style={{
                marginTop: 8,
                padding: '12px 0',
                borderRadius: 8,
                border: 'none',
                background: '#3f77e7',
                color: '#fff',
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer',
                transition: 'background .2s'
              }}
            >Отправить</button>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 0',
                borderRadius: 8,
                border: 'none',
                background: '#ededed',
                color: '#3f77e7',
                fontWeight: 600,
                fontSize: 15,
                cursor: 'pointer'
              }}
            >Отмена</button>
          </form>
        )}
      </div>
    </div>
  );
}
